import React from 'react';
import { Link } from 'react-router-dom';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { DropdownLink } from 'src/components/DropdownLink';
import { isConfluenceHubEnabled } from 'src/utils/featureGate';

import { LINKS } from './GlobalAppNavigation';

interface AdoptionDropdownProps {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
}

export const AdoptionDropdown = ({ isOpen, onToggle }: AdoptionDropdownProps): React.ReactElement => {
  const confluenceHubEnabled = isConfluenceHubEnabled();

  return (
    <DropdownLink title="Adoption" isOpen={isOpen} onToggle={onToggle} openOnHover={true}>
      <div css={adoptionDropdownContentStyles}>
        <Link
          to={LINKS.ADOPTION_AND_CHANGE_MANAGEMENT_GUIDE.href || '/'}
          css={adoptionLinkStyles}
          onClick={() => onToggle(false)}
        >
          {LINKS.ADOPTION_AND_CHANGE_MANAGEMENT_GUIDE.text}
        </Link>
        <Link to={LINKS.ROVO_ADOPTION_GUIDE.href || '/'} css={adoptionLinkStyles} onClick={() => onToggle(false)}>
          {LINKS.ROVO_ADOPTION_GUIDE.text}
        </Link>
        <Link to={LINKS.JIRA_ADOPTION_GUIDE.href || '/'} css={adoptionLinkStyles} onClick={() => onToggle(false)}>
          {LINKS.JIRA_ADOPTION_GUIDE.text}
        </Link>
        <Link to={LINKS.JIRA_CLOUD_ADOPTION_GUIDE.href || '/'} css={adoptionLinkStyles} onClick={() => onToggle(false)}>
          {LINKS.JIRA_CLOUD_ADOPTION_GUIDE.text}
        </Link>
        {confluenceHubEnabled && (
          <>
            <Link
              to={LINKS.CONFLUENCE_ADOPTION_GUIDE.href || '/'}
              css={adoptionLinkStyles}
              onClick={() => onToggle(false)}
            >
              {LINKS.CONFLUENCE_ADOPTION_GUIDE.text}
            </Link>
            <Link
              to={LINKS.CONFLUENCE_CLOUD_ADOPTION_GUIDE.href || '/'}
              css={adoptionLinkStyles}
              onClick={() => onToggle(false)}
            >
              {LINKS.CONFLUENCE_CLOUD_ADOPTION_GUIDE.text}
            </Link>
          </>
        )}
      </div>
    </DropdownLink>
  );
};

const adoptionDropdownContentStyles = css({
  padding: `${token('space.200')} ${token('space.100')}`,
  backgroundColor: '#FFFFFF',
  textAlign: 'left',
  width: 'fit-content',
  whiteSpace: 'nowrap',
});

const adoptionLinkStyles = css({
  display: 'block',
  padding: `${token('space.100')} ${token('space.150')}`,
  textDecoration: 'none',
  color: token('color.text'),
  fontFamily: 'Charlie Text, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  borderRadius: '4px',

  '&:hover': {
    color: token('color.link'),
    textDecoration: 'none',
  },
});
